import { Dispatcher as DispatcherClass } from "flux";
export const AppDispatcher = new DispatcherClass();
//# sourceMappingURL=AppDispatcher.js.map